import {
    CalculatorSecondary,
    FinanceEntry,
} from '../../../../../public/Images/finance_img';
import { useTranslation } from '@/hook';
import Typography from '@/components/shared/typography/typography.component';
import { useAnalytics } from '@/integrations';
import Link from '@/components/WrappedLink';

const FinanceCarCard = () => {
    const { t, i18n } = useTranslation();
    const { trackEvent } = useAnalytics();
    return (
        <div
            className={
                'block relative border border-gray-200  shadow-sm rounded-lg cursor-pointer'
            }
        >
            <div
                className={
                    'flex flex-col justify-between gap-2 flex-1 h-full py-6 px-5'
                }
            >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    src={FinanceEntry.src}
                    width={120}
                    height={120}
                    alt={''}
                    fetchPriority={'low'}
                    className="mx-auto"
                />
                <div
                    className={
                        'flex flex-row gap-2 text-secondary-600 text-base leading-7 items-center'
                    }
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        src={CalculatorSecondary.src}
                        alt={''}
                        fetchPriority={'low'}
                    />
                    <Typography variant={'body1Bold'}>
                        {t('FinanceEntryPoint.title')}
                    </Typography>
                </div>
                <Typography variant="body2">
                    {t('FinanceEntryPoint.subtitle')}
                </Typography>
                <Link
                    href={`/${i18n.language}/car-finance`}
                    onClick={() => {
                        trackEvent('Screen: Financing Page', {
                            sourceScreen: 'All Cars Listing',
                        });
                    }}
                >
                    <button
                        className={
                            'focus:outline-none bg-secondary-600 border border-gray-300 shadow-xs rounded-lg text-white w-full p-2 cursor-pointer'
                        }
                    >
                        <Typography variant={'body2Medium'}>
                            {t('FinanceEntryPoint.calculate')}
                        </Typography>
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default FinanceCarCard;
